import { createSlice } from "@reduxjs/toolkit";
import {
  getRequests,
  requestStatus,
  rescheduleRequest,
} from "../actions/request";
import { toast } from "react-toastify";

const states = {
  data: null,
  request: null,
  loading: false,
  error: false,
};

export const requests = createSlice({
  initialState: states,
  name: "requests",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRequests.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getRequests.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.request = action.payload.data;
    });
    builder.addCase(getRequests.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });

    builder.addCase(requestStatus.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(requestStatus.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      toast.success("Request status has been updated!");
    });
    builder.addCase(requestStatus.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
      toast.success("Sorry, something went wrong!");
    });

    builder.addCase(rescheduleRequest.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(rescheduleRequest.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
    });
    builder.addCase(rescheduleRequest.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });
  },
});

export default requests.reducer;
